import { hex_md5 } from './md5.js'
import choiceService from './choiceService';


export const PASSWORD_SALT = 'ChoiceSocialClub';

// const hashBrowser = async (val) => {
//     let h = await crypto.subtle.digest('SHA-256', new TextEncoder('utf-8').encode(val));
//     let hexes = [],
//     view = new DataView(h);
//     for (let i = 0; i < view.byteLength; i += 4) {
//         hexes.push(('00000000' + view.getUint32(i).toString(16)).slice(-8));
//     }
//     return hexes.join('');
// }


export const login = async (username, password) => {

    var hashedPassword = hex_md5('choicesocialclub' + password);

    try {
        //const hashedPassword = await hashBrowser(password+PASSWORD_SALT);
        const url = `/v1.0/auth/login?username=${encodeURIComponent(username)}&password=${encodeURIComponent(hashedPassword)}`;
        const res = await choiceService.post(url);
        return(res.data);
    } catch (err) {
        throw(err);
    }    
}

export const logout = async () => {
    console.log(`choice/auth.js::logout`)
    try {
        const url = `/v1.0/auth/logout`;
        await choiceService.post(url);
        return(true);
    } catch (error) {
        return(false);
    }    
}



export const resetPassword = async (username, email, token) => {
    try {
        //const hashedPassword = await hashBrowser(password+PASSWORD_SALT);
        const url = `/v1.0/auth/reset-password?username=${encodeURIComponent(username)}&email=${encodeURIComponent(email)}`;
        const res = await choiceService.post(url, { token: token });
        return (res.data);
    } catch (err) {
        throw (err);
    }
}



export const changePassword = async (oldPass, newPass) => {
    try {
        var hashedOldPass = hex_md5('choicesocialclub' + oldPass);
        var hashedNewPass = hex_md5('choicesocialclub' + newPass);

        //const hashedPassword = await hashBrowser(password+PASSWORD_SALT);
        const url = `/v1.0/auth/password?oldPassword=${encodeURIComponent(hashedOldPass)}&newPassword=${encodeURIComponent(hashedNewPass)}`;
        const res = await choiceService.put(url);
        return (res.data);
    } catch (err) {
        throw (err);
    }
}